module.exports = __webpack_public_path__ + "static/media/warning.04e760a9.png";